<template>
  <div class="mybookshelf-view">
    <nav-menu :navMenuList="navMenuList"
    :activeIndex="activeIndex"
    @handleSelect="handleSelect"></nav-menu>
    <div class="search-panel">
      <div class="allPage">
        共{{total}}本
      </div>
      <div class="d-search">
        <input type="text" placeholder="请输入书籍名称" v-model="searchWord">
        <button @click="cliclSearch">
          <i class="el-icon-search"></i>
        </button>
      </div>
    </div>
    <ul class="list-view">
      <li v-for="(item,index) in list" :key="index">
        <div class="left">
          <img :src="item.imgUrl" alt="">
        </div>
        <div class="right">
          <strong>{{item.name}}</strong>
          <!-- <p class="p-money">
            ￥{{item.money}}
            <span>
              定价：￥{{item.beforeMoney}}
            </span>
          </p> -->
          <p class="p-money">
            ￥{{item.promotionPrice ? item.promotionPrice : item.money}}
            <span v-show="item.promotionPrice ? true : false">
              定价：￥{{item.money}}
            </span>
          </p>
          <p class="p-eBookPrice">
            <span v-show="item.eBookPrice">
              电子书:￥
              <!-- {{item.eBookPrice}} -->
              {{item.paperPromotionPrice ? item.paperPromotionPrice : item.eBookPrice}}
              <span style="text-decoration: line-through" v-show="item.paperPromotionPrice">
                定价：{{item.eBookPrice}}
              </span>
            </span>
          </p>
          <p class="p-name">{{item.author}}</p>
          <button class="read-btn">立即购买</button>
          <div class="btns-d">
            <!-- <el-button @click="shoppingCart(item.isShoppingCart)" type="text"> -->
              <!-- <i :class="item.isShoppingCart ? 'el-icon-circle-close' : 'el-icon-circle-check'"></i> -->
              <img
              @click="shoppingCart(item)"
              :src="item.isShoppingCart ? gwc2 : gwc1"
              alt=""
              :class="item.isShoppingCart ? 'imgActive' : ''">
              <img @click="collection(item, index)" :src="item.isSc ? star2 : star1" alt="">
            <!-- </el-button> -->
            <!-- <el-button @click="collection" type="text"><i class="el-icon-star-on"></i></el-button> -->
          </div>
        </div>
      </li>
    </ul>
    <div class="pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'nav-menu': NavMenu
  },
  data () {
    return {
      currentPage: 1,
      activeIndex: '0',
      total: 0,
      pageSize: 10,
      searchWord: '',
      gwc1: require('@/assets/images/fl/gwc1.png'),
      gwc2: require('@/assets/images/fl/gwc2.png'),
      star1: require('@/assets/images/fl/star1.png'),
      star2: require('@/assets/images/fl/star2.png'),
      navMenuList: [{
        text: '我的收藏',
        pathName: ''
      }],
      list: []
    }
  },
  methods: {
    handleCurrentChange (val) {
      const start = (val - 1) * this.pageSize
      this.getFavorite(start)
    },
    cliclSearch () {
      this.getFavorite(0)
    },
    shoppingCart (item) { // 加入购物车
      const state = item.isShoppingCart
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!state) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}&type=0`
          const bookPrice = item.eBookPrice
          this.$get(this.$allUrl.addCart + par).then(res => {
            if (res.code === '0') {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              item.isShoppingCart = true
              this.$root.eventHub.$emit('update_shoppingNum')
            } else {
              this.$message.error('添加失败')
            }
          })
          if (bookPrice) {
            const par2 = `?bookId=${bookId}&userId=${userId}&type=1`
            this.$get(this.$allUrl.addCart + par2).then(res => {
              if (res.code !== '0') {
                this.$message.error('电子书加入购物车失败')
              } else {
                this.$root.eventHub.$emit('update_shoppingNum')
              }
            })
          }
        }
      }
    },
    collection (item, index) { // 收藏
      const userId = this.$store.state.userMsg.id
      const par = `?bookId=${item.id}&userId=${userId}`
      this.$get(this.$allUrl.deleteFavorite + par).then(res => {
        if (res.code === '0') {
          this.$notify({
            title: '成功',
            message: '已取消收藏',
            type: 'success',
            showClose: false,
            duration: 1500
          })
          const start = (this.currentPage - 1) * this.pageSize
          this.getFavorite(start)
        }
      })
    },
    handleSelect (key) {
      this.activeIndex = key
    },
    getFavorite (start) {
      const userId = this.$store.state.userMsg.id
      const pageSize = this.pageSize
      const searchWord = this.searchWord
      const par = `?userId=${userId}&start=${start}&num=${pageSize}&searchWord=${searchWord}`
      this.$get(this.$allUrl.getFavorite + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          this.total = res.recordsTotal // 总条数
          this.list = []
          const imgAdmin = this.$allUrl.imgAdmin
          list.forEach(e => {
            this.list.push({
              id: e.bookId,
              imgUrl: imgAdmin + e.coverUrl,
              name: e.bookName,
              author: e.bookAuthors,
              money: e.paperPrice, // 价格
              promotionPrice: e.promotionPrice,
              isShoppingCart: false,
              isSc: true,
              eBookPrice: e.emark === 0 ? '' : e.bookPrice, // 电子书价格
              paperPromotionPrice: e.paperPromotionPrice
            })
          })
        }
      })
    }
  },
  mounted () {
    this.getFavorite(0)
  }
}
</script>
<style lang="less" scoped>
  .mybookshelf-view{
    position: relative;
  }
  .pagination{
    text-align: right;
    padding: 50px 0;
  }
  .search-panel{
    height: 30px;
    width: 860px;
    position: absolute;
    right: 0;
    top: -2px;
    display: flex;
    line-height: 30px;
    .allPage{
      flex: 1;
      color: #7B6EA3;
      font-size: 14px;
      font-weight: 600;
    }
    .d-search{
      line-height: 20px;
      button{
        background-color: #B7151E;
        border: 0;
        outline: none;
        cursor: pointer;
        color: white;
        padding: 0 10px;
        height: 100%;
        float: right;
        font-size: 16px;
      }
      input{
        width: 200px;
        outline: none;
        border: 2px solid #B7151E;
        height: 24px;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
      }
    }
  }
  .list-view{
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    li{
      max-width: 50%;
      min-width: 50%;
      display: flex;
      padding: 40px 0;
      border-bottom: 1px solid #DBDBDB;
      p{
        padding: 0;
        margin: 0;
        font-size: 14px;
        padding-bottom: 10px;
        color: #9F9F9F;
      }
      .left{
        padding: 0 20px;
        img{
          width: 150px;
          height: 180px;
        }
      }
      .right{
        .star{
          padding-bottom: 10px;
        }
        .p-money{
          padding-top: 10px;
          font-weight: 600;
          color: red;
          font-size: 18px;
          span{
            font-size: 14px;
            color: #A0A0A0;
            font-weight: 200;
            text-decoration: line-through;
          }
        }
        .read-btn{
          width: 100px;
          height: 28px;
          background-color: #B7151E;
          color: white;
          outline: none;
          border: 0;
          border-radius: 6px;
          cursor: pointer;
        }
        .btns-d{
          padding-top: 20px;
          button{
            width: 40px;
            font-size: 24px;
            padding: 0;
            color: #B7151E;
          }
          img{
            padding: 0 10px;
            cursor: pointer;
          }
          .imgActive{
            cursor: auto;
          }
        }
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/MyCollection/mycollection.vue


// WEBPACK FOOTER //
// src/components/Personal/MyCollection/mycollection.vue